<template>
  <!-- the create form, in place: hosted in a modal so the list or board
       underneath never has to be left. no modal header -- the form's own
       header (title, close X) is the header. keyed per opening so every
       new ticket starts from a clean form. -->
  <b-modal :id="modalId" size="lg" hide-header hide-footer scrollable no-close-on-backdrop
           dialog-class="stcm-dialog" body-class="stcm-body"
           @hidden="onHidden">
    <support-ticket-create
      v-if="isOpen"
      :key="'create-' + opening"
      embedded
      :prefill="prefill"
      @close="$bvModal.hide(modalId)"
      @created="onCreated"
      @showAlert="(msg, variant, ms) => $emit('showAlert', msg, variant, ms)"
    />
  </b-modal>
</template>

<script>
import SupportTicketCreate from './support_ticket_create.vue'

// shared by the support ticket list and the Ticket Board. the host calls
// open(prefill?) and listens for `created` ({ tenant_id, id,
// attachmentFailures }) to refresh itself and, on a failed upload, open
// the new ticket for the retry. no-close-on-backdrop: a half-written
// ticket must not vanish on a stray click outside the form.
export default {
  name: 'SupportTicketCreateModal',
  components: { SupportTicketCreate },
  props: {
    modalId: { type: String, default: 'support-ticket-create-modal' },
  },
  data() {
    return { isOpen: false, opening: 0, prefill: null }
  },
  methods: {
    open(prefill = null) {
      this.prefill = prefill
      this.opening += 1
      this.isOpen = true
      this.$nextTick(() => this.$bvModal.show(this.modalId))
    },
    onCreated(result) {
      this._created = result
      this.$bvModal.hide(this.modalId)
    },
    onHidden() {
      const created = this._created || null
      this._created = null
      this.isOpen = false
      this.$emit('hidden', created)
      if (created) this.$emit('created', created)
    },
  },
}
</script>

<style>
/* portaled to <body>, so these are global. the form caps itself at
   1000px (stc-root); the body carries no padding of its own. */
.stcm-dialog.modal-lg { max-width: min(1040px, 96vw); margin: 1.5rem auto; }
.stcm-body { padding: 0; }
.stcm-body .stc-root { padding-top: 4px; }
@media (max-width: 720px) {
  .stcm-dialog.modal-lg { margin: 0.5rem; max-width: none; }
}
</style>
